import Image from "next/image";

import styled from "styled-components";

import { grayScale } from "@enkor/design/colors";

export const AVATAR_SIZE = {
  xs: 18,
  s: 20,
  m: 24,
  l: 32,
  xl: 40,
  xxl: 48,
} as const;

export type AvatarSizeType = keyof typeof AVATAR_SIZE;

const AvatarImageWrapper = styled.div<{
  $withBorder?: boolean;
  $size: AvatarSizeType;
}>`
  flex-shrink: 0;
  overflow: hidden;

  width: ${({ $size }) => AVATAR_SIZE[$size]}px;
  height: ${({ $size }) => AVATAR_SIZE[$size]}px;
  border: ${({ $withBorder }) =>
    $withBorder ? `1px solid ${grayScale.main}` : "none"};
  border-radius: 50%;
`;
export const AvatarWrapper = styled(AvatarImageWrapper)`
  margin-left: -4px;

  &:first-child {
    margin-left: 0;
  }
`;

export const Avatar = styled(Image)<{ $blur?: boolean }>`
  object-fit: cover;

  width: 100%;
  height: 100%;

  filter: ${({ $blur }) => ($blur ? "blur(5px)" : "none")};
`;
